import { degrees, PDFDocument, PDFEmbeddedPage } from 'pdf-lib';
import { Helvetica, HelveticaBold } from '~/assets/fonts/Helvetica';
import fontkit from '@pdf-lib/fontkit';
import axios from 'axios';
import { PAGE_FORMAT } from './constants/pdf';
import { IJsPDFWithPlugin } from './interface/common';
import { TIME_OUT } from './constants/common';

export const addCustomFont = async (pdfDoc: PDFDocument) => {
  pdfDoc.registerFontkit(fontkit);
  const normal = await pdfDoc.embedFont(Helvetica);
  const bold = await pdfDoc.embedFont(HelveticaBold);

  return { normal, bold };
};

export const psize = (value: number) => {
  return `${value}pt`;
};

export const formatHTML = (html?: string) => {
  if (!html) return html;
  html = html.replaceAll('<em', '<i').replaceAll('</em>', '</i>');
  html = html.replaceAll('<strong', '<b').replaceAll('</strong>', '</b>');
  return html;
};

export const debugRender = (html: string) => {
  const printPdfPreviewElement = document.querySelector('.pdf-debug-render');
  if (printPdfPreviewElement) printPdfPreviewElement.innerHTML = html;
};

export const getFile = async (url: string) => {
  const response = await axios({
    url: url,
    method: 'GET',
    responseType: 'arraybuffer',
    headers: {
      'Cache-Control': 'no-cache',
    },
    timeout: TIME_OUT,
  });
  return response.data;
};

export const isExist = (value: any): boolean => {
  return value != null && value !== '';
};

export const drawPageFromPDF = async (input: any) => {
  const { pdfDoc, doc, font, headerTitle, docType, headerTitle2, isScale } = input;
  const sourcePdfDoc = await PDFDocument.load(docType === 'arraybuffer' ? doc : doc.output('arraybuffer'));
  const embeddedPages = await pdfDoc.embedPages(sourcePdfDoc.getPages());

  let logo: any;
  if (headerTitle) {
    const responseData = await getFile('/logo.png');
    logo = await pdfDoc.embedPng(responseData);
  }

  embeddedPages.forEach((embeddedPage: PDFEmbeddedPage) => {
    const page = pdfDoc.addPage(PAGE_FORMAT);
    const width = page.getWidth();
    const height = page.getHeight();
    let drawX = 0;
    let drawY = 0;
    let drawPageWidth = width;
    let drawPageHeight = height;
    let rotate = degrees(0);
    if (isScale) {
      const embeddedPageSize = embeddedPage.size();
      // Portrait
      if (embeddedPageSize.width < embeddedPageSize.height) {
        const scale = width / embeddedPageSize.width;
        const scaledHeight = scale * embeddedPageSize.height;
        if (scaledHeight < drawPageHeight) drawPageHeight = scaledHeight;
        // Landscape
      } else {
        const scale = height / embeddedPageSize.height;
        const scaledWidth = scale * embeddedPageSize.width;
        if (scaledWidth < drawPageWidth) drawPageWidth = scaledWidth;
        drawPageHeight = drawPageWidth;
        drawPageWidth = height;

        rotate = degrees(-90);
        drawX = 0;
        drawY = height;
        page.setRotation(rotate);
      }
    }

    page.drawPage(embeddedPage, {
      x: drawX,
      y: drawY,
      rotate,
      width: drawPageWidth,
      height: drawPageHeight,
    });

    if (headerTitle) {
      const size = 20;
      if (headerTitle2) {
        page.drawText(headerTitle, {
          x: width / 2 - font.normal.widthOfTextAtSize(headerTitle ?? '', size) / 2,
          y: height - 40,
          size: size,
          font: font.bold,
        });

        if (headerTitle2) {
          page.drawText(headerTitle2, {
            x: width / 2 - font.normal.widthOfTextAtSize(headerTitle2 ?? '', size) / 2,
            y: height - 65,
            size: size,
            font: font.bold,
          });
        }
      } else {
        page.drawText(headerTitle, {
          x: width / 2 - font.normal.widthOfTextAtSize(headerTitle ?? '', size) / 2,
          y: height - 50,
          size: size,
          font: font.bold,
        });
      }

      if (logo) {
        page.drawImage(logo, {
          x: width - 100,
          y: height - 80,
          width: 60,
          height: 60,
        });
      }
    }
  });
};

export const resetDocStyle = (doc: IJsPDFWithPlugin) => {
  doc.setFont('Helvetica', 'normal');
  doc.setTextColor(0, 0, 0);
  doc.setFontSize(12);
};
